export default function adaptParentHeight() {
  return function link($scope, $element) {
    $scope.$watch(() => {
      $element.css('height', `${$element.parent()[0].offsetHeight}px`);
    });
  };
}
